module.exports = __webpack_public_path__ + "static/media/logo_round.421b6d39.svg";